import React from 'react'
import { css } from '@emotion/core'
import { Option, Select } from '@/components/atoms/select'
import { ReservationTaskStaff } from '@/models/reservation/reservation-task'
import { withCurrentStaff } from '@/utils/reservation-task'

/** 未設定に戻す選択肢「-」の値。未設定のタスクは value を undefined にして空欄で見せ、この値は選択肢にだけ使う */
const UNSET_VALUE = ''

type Props = {
  value: ReservationTaskStaff | null
  options: ReservationTaskStaff[]
  disabled: boolean
  onChange: (staffId: number | null) => void
}

export const TaskStaffSelect: React.FC<Props> = ({ value, options, disabled, onChange }) => {
  const onSelect = (selected: string) => {
    const staffId = selected === UNSET_VALUE ? null : Number(selected)
    // 同じスタッフを選び直したときは保存しない
    if (staffId === (value?.id ?? null)) {
      return
    }
    onChange(staffId)
  }

  return (
    <Select
      value={value ? String(value.id) : undefined}
      disabled={disabled}
      showArrow={false}
      onChange={selected => onSelect(String(selected))}
      dropdownMatchSelectWidth={false}
      customStyle={selectStyle}
    >
      <Option value={UNSET_VALUE}>-</Option>
      {withCurrentStaff(options, value).map(staff => (
        <Option key={staff.id} value={String(staff.id)}>
          {staff.name}
        </Option>
      ))}
    </Select>
  )
}

const selectStyle = css({
  width: 140,
  paddingBottom: 0,
})
